import { Module } from 'vuex'
import { StateInterface } from '../index'
import state, { PartnerState } from './state'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const partnersModule: Module<PartnerState, StateInterface> = {
  namespaced: true,
  actions,
  getters,
  mutations,
  state
}

export default partnersModule
